import React, { Component } from 'react'
import moment from 'moment'
import sort_icon from "../../../images/general/arrow_2.svg";
import sort_icon_up from "../../../images/general/arrow_1.svg";
import { useSelector, connect } from 'react-redux'
import * as actions from "../../../actions/actions";
import { withRouter } from 'react-router-dom';
import Loader from "../../../components/LoaderNew/Loader"
import _ from 'lodash'

class ReportsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data_array: this.props.reportsPageData.dataArray,
            sorted_tab: "process",
            sort_type_process: false,
            planned_value: false,
            actual_value: false,
            sort_amount: false,
            sort_billable: false
        }
    }

    sortDate = (sort_by) => {
        const { data_array, sort_type_process, planned_value, actual_value, sort_amount, sort_billable } = this.state;
        let copy_data = JSON.parse(JSON.stringify(data_array));
        let sort_data;

        if (sort_by === "process") {
            sort_data = copy_data.sort((a, b) => a[sort_by].localeCompare(b[sort_by]));
            if (!sort_type_process) sort_data.reverse();
            this.setState({ sort_type_process: !sort_type_process });

        } else if (sort_by === "planned") {
            sort_data = copy_data.sort((a, b) => a[sort_by] - b[sort_by]);
            if (!planned_value) sort_data.reverse();
            this.setState({ planned_value: !planned_value });

        } else if (sort_by === "actual") {
            sort_data = copy_data.sort((a, b) => a[sort_by] - b[sort_by]);
            if (!actual_value) sort_data.reverse();
            this.setState({ actual_value: !actual_value });
        } else if (sort_by === "count") {
            sort_data = copy_data.sort((a, b) => a[sort_by] - b[sort_by]);
            if (!sort_amount) sort_data.reverse();
            this.setState({ sort_amount: !sort_amount });
        } else if (sort_by === "billable") {
            sort_data = copy_data.sort((a, b) => a[sort_by] - b[sort_by]);
            if (!sort_billable) sort_data.reverse();
            this.setState({ sort_billable: !sort_billable });
        }

        this.setState({ data_array: sort_data, sorted_tab: sort_by }, () => {
            this.props.updateDataArray(sort_data);
        });
    }

    componentDidUpdate(prevProps) {
        const { reportsPageData } = this.props;

        if (reportsPageData?.dataArray && !_.isEqual(prevProps?.reportsPageData?.dataArray, reportsPageData.dataArray)) {
            this.setState({ data_array: reportsPageData.dataArray });
        }
    }

    render() {
        const { startingDate, endingDate, reportsPageData, isGenerated } = this.props;
        const { data_array, sorted_tab, sort_type_process, planned_value, actual_value, sort_amount, sort_billable } = this.state;

        return (
            <div className="new-reports-page__reports">
                <header>
                    <h1>דוח כספי</h1>
                    <h2>
                        <span>{typeof endingDate === "string" ? endingDate : moment(endingDate).format('DD/MM/YYYY')}</span>
                        <span> - </span>
                        <span>{typeof startingDate === "string" ? startingDate : moment(startingDate).format('DD/MM/YYYY')}</span>
                    </h2>
                </header>

                <section className="new-reports-page__reports__general-data">
                    <div className="reports-page__reports__general-data--section1">
                        <span>
                            <p>סה"כ מתוכנן:</p>
                            <p>{reportsPageData.total_planned ? reportsPageData.total_planned.toLocaleString() : 0}</p>
                        </span>
                    </div>
                    <div className="reports-page__reports__general-data--section2">
                        <span>
                            <p>יצא:</p>
                            <p>{reportsPageData.total_actual ? reportsPageData.total_actual.toLocaleString() : 0}</p>
                        </span>
                    </div>
                </section>

                <div className="new-reports-page__reports__main-data__header">
                    <p onClick={() => this.sortDate("process")}>
                        שלב {sorted_tab === "process" && <img className="sort__icon" src={sort_type_process ? sort_icon_up : sort_icon} alt="sort icon" />}
                    </p>
                    <p onClick={() => this.sortDate("count")}>
                        כַּמוּת {sorted_tab === "count" && <img className="sort__icon" src={sort_amount ? sort_icon_up : sort_icon} alt="sort icon" />}
                    </p>
                    <p onClick={() => this.sortDate("planned")}>
                        מתוכנן {sorted_tab === "planned" && <img className="sort__icon" src={planned_value ? sort_icon_up : sort_icon} alt="sort icon" />}
                    </p>
                    <p onClick={() => this.sortDate("billable")}>
                        יצא {sorted_tab === "billable" && <img className="sort__icon" src={sort_billable ? sort_icon_up : sort_icon} alt="sort icon" />}
                    </p>
                </div>

                {isGenerated
                    ? <section className="new-reports-page__reports__main-data">
                        {data_array && data_array.length > 0
                            ? data_array.map((item, idx) => (
                                <ReportRow key={item.process + idx} item={item} />
                            ))
                            : null
                        }
                    </section>
                    : <Loader />
                }
            </div>
        );
    }
}

function ReportRow({ item }) {
    return (
        <div className="new-reports-page__reports__main-data__item">
            <p>{item.process || '-'}</p>
            <p>{item.count ? item.count.toLocaleString() : 0}</p>
            <p>{item.planned ? item.planned.toLocaleString() : 0}</p>
            <p>{item.billable ? item.billable.toLocaleString() : 0}</p>
        </div>
    );
}

function mapStateToProps({ updateStagesInFinancialReport }) {
    return { updateStagesInFinancialReport };
}
export default withRouter(connect(mapStateToProps, actions)(ReportsPage));